'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AppBody = require('../AppBody');

var _AppBody2 = _interopRequireDefault(_AppBody);

var _AppBar = require('../AppBar');

var _AppBar2 = _interopRequireDefault(_AppBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function propTypeReactElement(propValue, key, componentName, location, propFullName) {
  if (!_react2.default.isValidElement(propValue)) {
    return new Error('Invalid prop `' + propFullName + '` supplied to' + ' `' + componentName + '`. Validation failed.');
  }
}

var AppFrame = function (_React$PureComponent) {
  _inherits(AppFrame, _React$PureComponent);

  function AppFrame() {
    _classCallCheck(this, AppFrame);

    return _possibleConstructorReturn(this, (AppFrame.__proto__ || Object.getPrototypeOf(AppFrame)).apply(this, arguments));
  }

  _createClass(AppFrame, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isInactive = _props.isInactive,
          display = _props.display,
          children = _props.children,
          iconUrl = _props.iconUrl,
          title = _props.title,
          badgeText = _props.badgeText,
          actions = _props.actions;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)("dp-AppFrame", isInactive ? 'is-inactive' : '', display === 'collapsed' ? 'is-colapsed' : '', this.props.className)
        },
        _react2.default.createElement(
          _AppBar2.default,
          { iconUrl: iconUrl, title: title, badgeText: badgeText },
          actions
        ),
        _react2.default.createElement(
          _AppBody2.default,
          null,
          children
        )
      );
    }
  }]);

  return AppFrame;
}(_react2.default.PureComponent);

exports.default = AppFrame;


AppFrame.propTypes = {

  /**
   * The url to the icon displayed in the bar
   */
  iconUrl: _propTypes2.default.string.isRequired,

  /**
   * The title displayed in the bar
   */
  title: _propTypes2.default.string.isRequired,

  /**
   * The text or number to display in the badge
   */
  badgeText: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * any additional classnames to be applied to the AppBar container
   */
  className: _propTypes2.default.string,

  /**
   * a list of actions associated with this component
   */
  actions: _propTypes2.default.oneOfType(_propTypes2.default.string, _propTypes2.default.func, propTypeReactElement, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, propTypeReactElement]))),

  /**
   * controls if the frame displays the inactive state
   */
  isInactive: _propTypes2.default.bool,

  /**
   * controls how the app frame is displayed
   */
  display: _propTypes2.default.oneOf(['collapsed', 'expanded'])
};

AppFrame.defaultProps = {

  className: "",

  isInactive: false,

  display: 'expanded'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/AppFrame/AppFrame.js
// module id = 339
// module chunks = 0